const GoogleDrivePicker =
    {

        install(Vue, options) {

            let oauthToken = null;
            options = options || {};
            Vue.opts = {};
            Vue.cb = null;

            // options.scope = options.scope || ['https://www.googleapis.com/auth/drive'];
            // options.origin = options.origin || (window.location.protocol + '//' + window.location.host);
            options.upload = options.upload || true;
            options.folders = options.folders || true;
            options.projects_folder = options.projects_folder || '';

            Vue.onAuthApiLoad = function () {
                window.gapi.auth.authorize({
                    'client_id': options.google_client_id,
                    'scope': ['https://www.googleapis.com/auth/drive']
                }, Vue.handleAuthResult);
            };

            Vue.handleAuthResult = function (authResult) {
                if (authResult && !authResult.error) {
                    oauthToken = authResult.access_token;
                    Vue.createPicker();
                }
            };

            Vue.createPicker = function () {
                let picker = new google.picker.PickerBuilder();

                if (Vue.opts.upload) {
                    let uploadView = new google.picker.DocsUploadView();
                    uploadView.setIncludeFolders(true);
                    picker.addView(uploadView);
                }

                let docView = new google.picker.DocsView(google.picker.ViewId.FOLDERS);
                if (Vue.opts.folders) {
                    docView.setSelectFolderEnabled(true);
                }
                docView.setParent(Vue.opts.projects_folder);


                picker = picker.setOAuthToken(oauthToken)
                    .addView(docView)
                    .setCallback(data => {
                        if (data.action === google.picker.Action.PICKED) {
                            if (Vue.cb) {
                                Vue.cb(data.docs);
                                Vue.cb = null;
                            } else {
                                console.error('No callback set after pick document from Google Drive');
                            }
                        }
                    })
                    .build();
                picker.setVisible(true);

            };

            Vue.prototype.$pick = function (opts, cb) {
                if (arguments.length === 1) {
                    cb = opts;
                    opts = {};
                }
                opts = opts || {};
                Vue.cb = cb;

                Object.keys(options).forEach(function (key) {
                    if (!opts.hasOwnProperty(key))
                        opts[key] = options[key];
                });

                console.log(opts);

                if (!window.gapi) {
                    throw new Error('[GoogleDrive] cannot locate gapi')
                }
                if (!opts.projects_folder) {
                    throw new Error('[GoogleDrive] parent project folder not set')
                }

                Vue.opts = opts;

                if (oauthToken != null) {
                    Vue.createPicker();
                } else {
                    window.gapi.load('auth', {'callback': Vue.onAuthApiLoad});
                    window.gapi.load('picker');
                }


            }

        }
    };

export default GoogleDrivePicker;


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/GoogleDrive.js